import { render, staticRenderFns } from "./HistorySimpleAbsence.vue?vue&type=template&id=25fddfe8&"
import script from "./HistorySimpleAbsence.vue?vue&type=script&lang=js&"
export * from "./HistorySimpleAbsence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports